import Actions from 'actions'
import { of } from 'rxjs'
import { trackEvent } from 'utils/analyticsUtils'

const BULK_CREATE_PATIENTS_UPLOAD_STORAGE_KEY = 'bulk-create-patients-upload'
const getBulkCreatePatientsUploadStorageKey = doctorId =>
  doctorId ? `${BULK_CREATE_PATIENTS_UPLOAD_STORAGE_KEY}:${doctorId}` : BULK_CREATE_PATIENTS_UPLOAD_STORAGE_KEY

export const getPersistedBulkCreatePatientsUpload = doctorId => {
  if (typeof localStorage === 'undefined') {
    return null
  }

  try {
    return JSON.parse(localStorage.getItem(getBulkCreatePatientsUploadStorageKey(doctorId)) || 'null')
  } catch (ex) {
    return null
  }
}

export const persistBulkCreatePatientsUpload = ({ uploadId, fileName, doctorId }) => {
  if (typeof localStorage === 'undefined' || !uploadId || !doctorId) {
    return
  }

  const persistedUpload = getPersistedBulkCreatePatientsUpload(doctorId) || {}
  localStorage.setItem(
    getBulkCreatePatientsUploadStorageKey(doctorId),
    JSON.stringify({
      ...persistedUpload,
      doctorId,
      uploadId,
      fileName: fileName || persistedUpload.fileName || null
    })
  )
}

export const clearPersistedBulkCreatePatientsUpload = doctorId => {
  if (typeof localStorage === 'undefined') {
    return
  }

  if (doctorId) {
    localStorage.removeItem(getBulkCreatePatientsUploadStorageKey(doctorId))
  }

  localStorage.removeItem(BULK_CREATE_PATIENTS_UPLOAD_STORAGE_KEY)

  Object.keys(localStorage)
    .filter(key => key.startsWith(`${BULK_CREATE_PATIENTS_UPLOAD_STORAGE_KEY}:`))
    .forEach(key => localStorage.removeItem(key))
}

export const handleBulkCreatePatientsError = (error, uploadId = null) => {
  const errorData = error?.response?.data || error?.data || {}
  const statusCode = error?.response?.status || error?.status || 500
  const summary = errorData?.details?.summary
  const validationErrorCsvUrl = errorData?.details?.validationErrorCsvUrl
  // Only the server's `validations` payload means the doctor's CSV is at fault. Anything else here is
  // the upload itself failing (media edge rejection, network, S3) and must not be reported as bad rows.
  const failureType = errorData?.validations ? 'validation' : 'upload'

  trackEvent('bulk create patients - error', {
    error: error?.message,
    statusCode,
    uploadId,
    failureType,
    invalidRows: errorData?.validations?.rows?.length
  })

  return of(
    Actions.validateBulkCreatePatientsFormFailed({
      uploadId,
      statusCode,
      summary,
      validationErrorCsvUrl,
      failureType,
      errors: errorData?.validations || {
        form: errorData?.message || 'upload-failed'
      }
    })
  )
}

export const handleBulkCreatePatientsSubmitError = error => {
  const errorData = error?.response?.data || error?.data || {}
  const statusCode = error?.response?.status || error?.status || 500

  trackEvent('bulk create patients - submit error', {
    error: error?.message,
    statusCode
  })

  return of(
    Actions.submitBulkCreatePatientsFailed({
      statusCode,
      failureType: 'submit',
      errors: {
        form: errorData?.message || 'submit-failed'
      }
    })
  )
}
